import React, { Component, Fragment } from 'react';
import { Button, List, Row, Col, Popconfirm, Tooltip } from 'antd';
import styles from './sa-feed.module.sass';
import Icon, {
  DeleteOutlined,
  EditOutlined,
  PlusCircleFilled,
} from '@ant-design/icons';
import { STATUS } from '../../../../redux/constants';

class FeedList extends Component {
  componentDidMount() {
    this.props.resetFeedStatus();
  }

  handleAddClick = () => {
    this.props.onItemAdd(null);
  };

  handleEditClick = (item) => {
    this.props.onItemEdit(item);
  };

  handleDeleteClick = (item) => {
    this.props.onItemDelete(item);
  };

  render() {
    const { globalFeeds, status } = this.props;
    return (
      <Fragment>
        <h1>Custom Feed Consumers</h1>

        <div className={styles['add-btn-container']}>
          <Button
            disabled={
              !this.props.user?.subscription_info?.can_create_custom_feed
            }
            icon={<Icon component={PlusCircleFilled} />}
            className={styles['add-btn']}
            onClick={this.handleAddClick}
          >
            Create New Feed
          </Button>
        </div>

        <List
          loading={status === STATUS.LOADING}
          header={
            <Row className={styles.row}>
              <Col span={6}>Feed Name</Col>
              <Tooltip title="Type of the source (domain/IP/URL)">
                <Col span={6}>Type</Col>
              </Tooltip>
            </Row>
          }
          locale={{
            emptyText: 'No Feeds',
          }}
          bordered
          dataSource={globalFeeds}
          renderItem={(item) => (
            <List.Item>
              <Row style={{ width: '100%' }} className={styles.row}>
                <Col span={6}>{item.name}</Col>
                <Col span={6}>{item.type}</Col>

                <Col span={6}>
                  <div className={styles['action-buttons']}>
                    <EditOutlined onClick={() => this.handleEditClick(item)} />
                    <Popconfirm
                      title="Are you sure?"
                      onConfirm={() => this.handleDeleteClick(item)}
                    >
                      <DeleteOutlined />
                    </Popconfirm>
                  </div>
                </Col>
              </Row>
            </List.Item>
          )}
        />
      </Fragment>
    );
  }
}

export default FeedList;
